<mat-card style="border: 0px solid black">
<mcrit-gestio-manage-project-data style="display:flex; flex-direction:column;"
  [showAsyncProgress]="showAsyncProgress"
  [isNew]="(id === 'new')"
  [data]="projectInformation"
  (requestChange)="dataChangeRequested($event)">
</mcrit-gestio-manage-project-data>
<mcrit-gestio-document style="display:flex; flex-direction:column;" class="equiWColElement"
  [tipus]="'treballs'"
  [codi]="id">
</mcrit-gestio-document>
<mcrit-gestio-manage-project-clients-socis-list style="display:flex; flex-direction:column;"
  [showAsyncProgress]="showAsyncProgress"
  [clientsSocisList]="projectProjectClients"
  [idProjecte]="id"
  [routekey]="'project'"
  [tipus]="'Contactes'"
  (changeClientSoci)="changeClientContacteProject($event)"
  (deleteClientSoci)="deleteClientContacteProject($event)"
   class="equiWColElement">
</mcrit-gestio-manage-project-clients-socis-list>
<mcrit-gestio-manage-project-collaborator-list style="display:flex; flex-direction:column;"
  [showAsyncProgress]="showAsyncProgress"
  [collaboratorList]="projectCollaborators"
  [idProjecte]="id"
  [idProposal]=""
  (changeCollaborator)="changeCollaborator($event)"
   class="equiWColElement">
 </mcrit-gestio-manage-project-collaborator-list>
 <mcrit-gestio-manage-project-control-tecnic style="display:flex; flex-direction:column;"
  [aggregates]="hourCount"
  [totalHores]="hourProj"
  class="equiWColElement">
 </mcrit-gestio-manage-project-control-tecnic>
</mat-card>
<!-- template syntax angular2 -->
<mat-card *ngIf="error" class="error" style="float:left;clear:both;width:100%;visibility:hidden">
  <mat-card-title align="center">Error {{error.status}}</mat-card-title>
  <mat-card-subtitle align="center">{{error.statusText}}</mat-card-subtitle>
  <mat-card-content align="center">
    <p>{{error.msg}}</p>
  </mat-card-content>
</mat-card>
